export default __webpack_public_path__ + "media/images/features/yado/subtitle_pc-51d223498f887dababcbb02f462c3f05.png";